import { Component, ErrorInfo, ReactNode } from 'react';
import DesignError from './ErrorDesign';
import { v4 as uuidv4 } from 'uuid';
import * as Sentry from '@sentry/react';

type ErrorBoundaryProps = {
  children?: ReactNode;
};
type ErrorBoundarystate = {
  hasError: boolean;
  errorId: string;
  error: Error | null;
  errorInfo: ErrorInfo | null;
};

class GlobalErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundarystate> {
  state: ErrorBoundarystate = {
    hasError: false,
    errorId: '',
    error: null,
    errorInfo: null,
  };

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    Sentry.captureReactException(error, errorInfo);
    this.setState({
      hasError: true,
      errorId: uuidv4(),
      error: error,
      errorInfo: errorInfo,
    });
  }

  render() {
    if (this.state.hasError && this.state.error && this.state.errorInfo) {
      return (
        <>
          <DesignError
            errorId={this.state.errorId}
            error={this.state.error}
            errorInfo={this.state.errorInfo}
          />
        </>
      );
    }
    return this.props.children;
  }
}
export default GlobalErrorBoundary;
